const breadCrumb = "Lançamento de Notas - Lançamento de Notas/Conceitos/Faltas";

const routes = [
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos/:id/:periodoId/turmas-iniciadas",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos-turmas-iniciadas",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/ConsultarResumoDeLancamentoDeNotasConceitosTurmasIniciadas.vue"
      ),
  },
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos/:id/turmas-iniciadas/:turmaId",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos-turmas-iniciadas-detalhe",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/TurmasIniciadas/DisciplinaAreaDoConhecimento.vue"
      ),
  },
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos/:id/turmas-iniciadas/:turmaId/alunos-sem-nota-zero/:resumoId",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos-turmas-iniciadas-alunos-sem-nota-zero",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/TurmasIniciadas/AlunosSemNotaZero.vue"
      ),
  },
  {
    path: "/consultar-resumo-de-lancamento-de-notas-conceitos/:id/turmas-iniciadas/:turmaId/alunos-com-nota-zero/:resumoId",
    name: "consultar-resumo-de-lancamento-de-notas-conceitos-turmas-iniciadas-alunos-com-nota-zero",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultarResumoDeLancamentoDeNotasConceitos/TurmasIniciadas/AlunosComNotaZero.vue"
      ),
  },
];

export default routes;
